import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      title: '首页',
      index: 0,
      keepAlive: true,
      showTabBar: true,
      requiresAuth: true
    }
  },
  {
    path: '/flash-sale',
    name: 'FlashSale',
    component: () => import(/* webpackChunkName: "flash-sale" */ '@/views/FlashSale.vue'),
    meta: {
      title: '抢购',
      index: 1,
      showTabBar: true,
      requiresAuth: true
    }
  },
  {
    path: '/agent-center',
    name: 'AgentCenter',
    component: () => import(/* webpackChunkName: "agent-center" */ '@/views/AgentCenter.vue'),
    meta: {
      title: '代理商中心',
      index: 2,
      showTabBar: true,
      requiresAuth: true
    }
  },
  {
    path: '/flash-detail',
    name: 'FlashDetail',
    component: () => import(/* webpackChunkName: "flash-detail" */ '@/views/FlashDetail.vue'),
    meta: {
      title: '抢购详情',
      showTabBar: false,
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Login.vue'),
    meta: {
      title: '登录',
      index: 99,
      showTabBar: false,
      guestOnly: true
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import(/* webpackChunkName: "agreement" */ '@/views/Agreement.vue'),
    meta: { title: '协议', showTabBar: false }
  },
  {
    path: '/my-fans',
    name: 'MyFans',
    component: () => import(/* webpackChunkName: "fans" */ '@/views/MyFans.vue'),
    meta: { title: '我的粉丝', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/invite-friends',
    name: 'InviteFriends',
    component: () => import(/* webpackChunkName: "invite" */ '@/views/InviteFriends.vue'),
    meta: { title: '邀请好友', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import(/* webpackChunkName: "payment" */ '@/views/Payment.vue'),
    meta: { title: '收款方式', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/payment-edit',
    name: 'PaymentEdit',
    component: () => import(/* webpackChunkName: "payment" */ '@/views/PaymentEdit.vue'),
    meta: { title: '设置收款方式', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/ResetPassword.vue'),
    meta: { title: '找回密码', showTabBar: false, guestOnly: true }
  },
  {
    path: '/wallet-log',
    name: 'WalletLog',
    component: () => import(/* webpackChunkName: "wallet-log" */ '@/views/WalletLog.vue'),
    meta: { title: '明细', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/Settings.vue'),
    meta: { title: '设置', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/OrderList.vue'),
    meta: { title: '订单', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: () => import(/* webpackChunkName: "order-detail" */ '@/views/OrderDetail.vue'),
    meta: { title: '订单详情', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/product-detail',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "product-detail" */ '@/views/ProductDetail.vue'),
    meta: { title: '商品详情', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/order-pay',
    name: 'OrderPay',
    component: () => import(/* webpackChunkName: "order-pay" */ '@/views/OrderPay.vue'),
    meta: { title: '支付订单', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/contract-sign',
    name: 'ContractSign',
    component: () => import(/* webpackChunkName: "contract" */ '@/views/ContractSign.vue'),
    meta: { title: '合同签署', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/sign-pad',
    name: 'SignPad',
    component: () => import(/* webpackChunkName: "contract" */ '@/views/SignPad.vue'),
    meta: { title: '签名', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/my-contract',
    name: 'MyContract',
    component: () => import(/* webpackChunkName: "contract" */ '@/views/MyContract.vue'),
    meta: { title: '我的合同', showTabBar: false, requiresAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Register.vue'),
    meta: {
      title: '注册',
      index: 99,
      showTabBar: false,
      guestOnly: true
    }
  }
]

// history 模式（C 方案：全站整页导航）。
// 页面之间全部走真实浏览器导航（跨文档），浏览器才能保存每个页面的
// 真实快照 + bfcache，左滑返回时直接秒开上一页、零闪烁。
const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫：未登录强制跳到登录页（整页导航下每次加载都会执行）
router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()

  if (to.meta.requiresAuth && !loggedIn) {
    next('/login')
  } else if (to.meta.guestOnly && loggedIn) {
    next('/home')
  } else {
    next()
  }
})

export default router
